export const en = {
  // Common
  loading: "Loading...",
  save: "Save",
  cancel: "Cancel",
  delete: "Delete",
  edit: "Edit",
  search: "Search",
  filter: "Filter",
  confirm: "Confirm",
  error: "Error",
  success: "Success",
  filters: "Filters",
  next: "Next",
  previous: "Previous",
  page: "Page",
  pageInfo: "Page {{current}} of {{total}}",
  back: "Back",
  activate: "Activate",
  contactPerson: "Contact Person",
  postalCode: "Postal Code",
  additionalNumber: "Additional Number",
  kingdomOfSaudiArabia: "Kingdom of Saudi Arabia",
  signOut: "Sign out",
  // Not Found Page
  notFound: {
    title: "Page Not Found",
    description: "The page you're looking for doesn't exist or has been moved.",
  },
  // Shared - Table translations
  shared: {
    signIn: "Sign in",
    table: {
      id: "ID",
      sku: "SKU",
      tenantName: "Tenant Name",
      type: "Type",
      city: "City",
      numberOfBranches: "Number of Branches",
      status: "Status",
      discountPercent: "Discount %",
      contactName: "Contact Name",
      contactDetails: "Contact Details",
      dateCreated: "Date Created",
      actions: "Actions",
      hospital: "Hospital",
      clinic: "Clinic",
      other: "Other",
      active: "Active",
      pending: "Pending",
      previous: "Previous",
      next: "Next",
      page: "Page",
      of: "of",
      product: "Product",
      category: "Category",
      brand: "Brand",
      productStatus: "Product Status",
      variationGroup: "Variation Group",
      price: "Price",
      published: "Published",
      draft: "Draft",
      edit: "Edit",
      copy: "Copy",
      inactive: "In-active",
    },
    entityType: {
      POLY_CLINIC: "Poly Clinic",
      HOSPITAL: "Hospital",
      OTHER: "Other",
    },
    tenantActivation: {
      activateNow: "Activate Now",
      activateNowDescription: "You can activate this tenant now or complete setup later.",
      activateNowLabel: "Activate now",
      notNowLabel: "Not now",
      successTitle: "Activation is pending",
      successDescription: "Activate the tenant to allow them to access the system.",
      confirm: "Activate",
      // Modal title and subtitle
      modalTitle: "Activate Tenant",
      modalSubtitle: "Review details and complete setup before granting access.",
      // Stepper steps
      stepReviewInfo: "Review Info",
      stepAssignBranch: "Assign Branch",
      stepConfirmActivate: "Confirm",
      // Button labels
      cancel: "Cancel",
      next: "Next",
    },
    // Sidebar translations
    sidebar: {
      dashboard: "Dashboard",
      tenants: "Tenants",
      users: "Users",
      catalog: "Catalog",
      catalogAssignment: "Catalog Assignment",
      purchase: "Purchase Orders",
      purchaseRequests: "Purchase Requests",
      branches: "Branches",
      purchaseOrders: "Purchase Orders",
    },
    tableToolbar: {
      viewAll: "View all",
      active: "Active",
      pending: "Pending",
      searchPlaceholder: "Search",
      filters: "Filters",
    },

    // Form validation and field labels
    branchForm: {
      // Form field labels
      branchName: "Branch name",
      city: "City",
      district: "District",
      address: "Address",
      contactFirstName: "Contact person first name",
      contactLastName: "Contact person last name",
      contactEmail: "Contact person Email",
      contactPhone: "Contact person number",

      // Placeholders
      branchNamePlaceholder: "Enter branch name",
      cityPlaceholder: "Select city",
      districtPlaceholder: "Enter district name",
      addressPlaceholder: "Enter address",
      firstNamePlaceholder: "Enter first name",
      lastNamePlaceholder: "Enter last name",
      emailPlaceholder: "Enter user email",
      phonePlaceholder: "Enter without country code",

      // Validation messages
      required: "Required",
      invalidEmail: "Invalid email address",
      maxLength: "Cannot exceed 50 characters",
      minLength: "Must be at least 3 characters long",
      invalidPhone: "Invalid phone number",
      invalidAddress: "Only characters are allowed",
      invalidBranchName: "Only characters are allowed",
      invalidAlphaNumeric: "Only characters and numbers are allowed",
      minLengthAddress: "Must be at least 10 characters long",
      maxlengthDynamic: "Cannot exceed {{max}} characters",

      // Country names
      countries: {
        SA: "Saudi Arabia",
        EG: "Egypt",
        AE: "United Arab Emirates",
      },
    },

    // Add WrongPortal translations
    wrongPortal: {
      title: "Access Denied",
      description: "You don't have the right credentials to access this portal.",
      contactAdmin: "Please contact your administrator or try signing in to the correct portal.",
      tryAgain: "Try Again",
      goToHub: "Go to Surgia Hub",
      goToAdmin: "Go to Surgia Admin",
      accessDeniedToast: "Access Denied",
      accessDeniedDescription: "Try signing in to the correct portal.",
    },
    filters: {
      priceRange: "Price range",
    },
  },

  //hub
  hub: {
    // Common form fields
    formFields: {
      clinicHospitalName: "Clinic/Hospital Name",
      clinicHospitalType: "Clinic/Hospital Type",
      country: "Country",
      city: "City",
      firstName: "First Name",
      lastName: "Last Name",
      email: "Contact Person Email",
      mobile: "Contact Person Mobile"
    },
    placeholders: {
      clinicHospitalName: "Enter clinic/hospital name",
      clinicHospitalType: "Select type",
      country: "Select country",
      city: "Select city",
      firstName: "First name",
      lastName: "Last name",
      email: "Enter contact email",
      mobile: "Enter without country code",
      loadingCities: "Loading cities..."
    },
    // Register page specific
    register: {
      pageTitle: "Register your Business",
      pageSubtitle: "Please fill out your information to request account",
      contactEmail: "info@surgia.co",
      submit: "Submit",
      submitting: "Submitting...",
      existingAccount: "Already have an account?",
      signIn: "Sign in",
      mobile: "Enter phone number",
      // Error messages
      nameExists: "Clinic/Hospital Name already exists",
      branchNameExists: "Branch name already exists",
      emailExists: "This Email already exists",
      mobileExists: "This Mobile number already exists",
      offlineError: "You are offline. Please check your internet connection.",
      successMessage: "Request was submitted successfully"

    },
    verifyInvitation: {
      invitationVerified: "Invitation Verified!",
      invitationError: "Invitation Error",
      verifying: "Verifying your invitation...",
      successTitle: "Success!",
      successMessage: "Your invitation has been verified. Redirecting to sign in page in {{count}} second{{plural}}...",
      signInNow: "Sign In Now",
      verificationFailed: "Verification Failed",
      verificationFailedMessage: "Invalid or expired invitation token. Please request a new invitation.",
      returnHome: "Return Home",
      invitationValidationFailed: "Invitation validation failed"
    }
  },

  //admin
  admin: {
    // Navigation
    dashboard: "Dashboard",
    tenants: "Tenants",
    tenantsSubtitle: "Manage and monitor all institutional accounts",
    createNew: "Create new",
    products: "Products",

    // Admin-specific content
    welcome: "Welcome to Surgia Admin Portal",
    manageTenants: "Manage Tenants",
    addBranch: "Add Branch",

    // Roles specific to healthcare
    admin: "Admin",
    procurement: "Procurement Manager",
    clinical: "Clinical Operator",

    // Table Actions and States
    activate: "Activate",

    // Filters Modal
    idRange: "ID range (e.g 1333-1350)",
    selectCity: "Select city",
    selectType: "Select type",
    selectStatus: "Select status",
    discount: "Discount",
    discountPercentage: "Discount percentage",
    selectDateOrRange: "Select a date or range",
    clearFilters: "Clear filters",

    // Users Tab Section
    generalInfo: "General Info",
    branches: "Branches",
    catalog: "Catalog",
    complianceDocuments: "Compliance Documents",
    purchaseOrders: "Purchase Orders",
    allBranches: "All branches",
    addUser: "Add user",
    toasters: {
      tenantActicated: "Tenant was activated successfully!",
      tenantActivationFailed: "Failed to activate Tenant",
      tryAgain: "Please try again later.",
      branchCreated: "Branch was created successfully ",
    },

    // Product Assignment Page
    productAssignment: {
      pageTitle: "Assign product",
      pageSubtitle: "Set up and configure products for your catalog",
      tenantName: "King Faisal Specialist Hospital",
      breadcrumb: {
        tenants: "Tenants",
        tenantDetails: "Tenant Details",
        assignProduct: "Assign product"
      },
      actions: {
        cancel: "Cancel",
        saveAsDraft: "Save as a draft",
        previous: "← Previous",
        next: "Next →",
        finish: "Finish"
      },
      steps: {
        selectProducts: {
          title: "Select products",
          subtitle: "from the common products",
          loadingProducts: "Loading products..."
        },
        configureDetails: {
          title: "Configure Details",
          subtitle: "Assign variants and customize product names."
        },
        customerView: {
          title: "Customer view",
          subtitle: "Control customer catalog view"
        }
      },
      content: {
        selectProducts: {
          title: "Select products",
          commonProducts: "Common products",
          searchPlaceholder: "Search by Name or ID",
          filters: "Filters",
          productsSelected: "Products selected",
          configureDetails: "Content for configuring product details and variants.",
          customerView: "Content for controlling customer catalog view."
        }
      },
      messages: {
        productsAssignedSuccess: "Products assignment completed successfully!",
        productsAssignedError: "Failed to assign products",
        tryAgain: "Please try again",
        selectAtLeastOne: "Please select at least one product",
        assigning: "Assigning...",
        loadingProducts: "Loading products...",
        noProductsFound: "No products found",
        noProductsSelected: "No products selected",
        // Add these new messages
        saveProgressGoBack: "Save Progress & Go Back",
        saveProgressSubtitle: "Your current product selections will be saved as a draft before going back.",
        stayHere: "Stay Here",
        saveAndGoBack: "Save & Go Back",
        goingBackMessage: "Going back will allow you to select different products while preserving your current selections as a draft for later use.",
        failedToUpdateVisibility: "Failed to update visibility. Please try again.",
        loadingProductsMessage: "Loading products...",
        // Add these new messages for the footer section
        productsSelected: "Products selected",
        previous: "← Previous",
        finish: "Finish"
      },
      filters: {
        priceFilterError: "Price filter should have both minimum and maximum values",
        selectCategory: "Select a category",
        selectBrand: "Select a brand",
        priceRange: "Price range",
        category: "Category",
        brand: "Brand",
      },
      specifyVariantsTitle: "Specify variants",
      loadingProducts: "Loading products...",
      changesDiscarded: "Changes discarded",
    },

    // Tenant Details Page
    tenantDetails: {
      pageTitle: "Tenant Details",
      breadcrumb: {
        tenants: "Tenants",
        tenantDetails: "Tenant Details"
      },
      actions: {
        addBranch: "Add Branch"
      },
      tabs: {
        generalInfo: "General Info",
        branches: "Branches",
        users: "Users",
        catalog: "Catalog",
        complianceDocuments: "Compliance Documents",
        purchaseRequests: "Purchase requests",
        purchaseOrders: "Purchase orders"
      },
      content: {
        generalInfo: {
          title: "General Information",
          description: "General tenant information and details"
        },
        branches: {
          title: "Branches",
          description: "Manage tenant branches and locations"
        },
        users: {
          title: "Users",
          description: "Manage tenant users and permissions"
        },
        catalog: {
          title: "Catalog",
          description: "Manage tenant product catalog"
        },
        complianceDocuments: {
          title: "Compliance Documents",
          description: "Manage compliance and regulatory documents"
        },
        purchaseRequests: {
          title: "Purchase Requests",
          description: "View and manage purchase requests"
        },
        purchaseOrders: {
          title: "Purchase Orders",
          description: "View and manage purchase orders"
        }
      },
      messages: {
        tenantActivated: "Tenant was activated successfully!",
        tenantActivationFailed: "Failed to activate Tenant",
        tryAgain: "Please try again later.",
        activateNow: "Activate Now",
        activateNowDescription: "You can activate this tenant now or complete setup later.",
        activateNowLabel: "Activate now",
        notNowLabel: "Not now",
        successTitle: "Activation Successful",
        successDescription: "The tenant has been successfully activated and can now access the system.",
        confirm: "Confirm",
        modalTitle: "Activate Tenant",
        modalSubtitle: "Review details and complete setup before granting access.",
        stepReviewInfo: "Review Info",
        stepAssignBranch: "Assign Branch",
        stepConfirmActivate: "Confirm",
        cancel: "Cancel",
        next: "Next"
      }
    },

    productCard: {
      variant: "Variant",
      variants: "Variants",
      customerProductName: "Customer product name",
      customerProductNamePlaceholder: "Customer product name",
      customerProductNameHelp: "This name will appear in the customer's catalog.",
      productVariants: "Product Variants",
      cancel: "Cancel",
      save: "Save",
      expand: "expand",
      collapse: "collapse",
      selection: "selection",
      variantSelection: "variant selection",
      product: "product"
    }
  },

  // Validation
  required: "This field is required",
  invalid_email: "Invalid email format",
  password_too_short: "Password must be at least 8 characters",
  passwords_dont_match: "Passwords don't match",
} as const; 